import _ from 'lodash/fp'
import {
  createNewRecord,
  getFileNameAndExtension,
  IGNORED_FILE_PATTERNS,
  IGNORED_FILES,
  readFileAsText,
  RecordClass,
  RecordFormat,
  VALID_EXTENSIONS,
  checkCCDAXSLT,
} from '../utils'
import { processQueue } from './queues'

const isIgnoredFile = file => {
  if (IGNORED_FILES.indexOf(file.name) >= 0) {
    return true
  }
  if (IGNORED_FILE_PATTERNS.find(pattern => pattern.test(file.name))) {
    return true
  }
  return false
}

export const isNonDicom = file => {
  if (file.size === 0) {
    return true
  }
  if (
    file.type !== undefined &&
    file.type !== null &&
    file.type !== '' &&
    file.type.toLowerCase() !== 'application/dicom'
  ) {
    return true
  }
  return false
}

const isValidNonDicom = file =>
  VALID_EXTENSIONS.indexOf(file.name.toLowerCase().split('.').pop()) >= 0

const isNonDicomAndValid = file => isNonDicom(file) && isValidNonDicom(file)

const getClassAndFormat = file => {
  const [filename, extension] = getFileNameAndExtension(file)
  if (['pdf', 'txt'].indexOf(extension) >= 0) {
    return [RecordClass.Clinical, extension.toUpperCase()]
  }
  return [RecordClass.Other, RecordFormat.Other]
}

const createRecord = (file, ccda = false) => {
  const [recordClass, recordFormat] = ccda
    ? [RecordClass.Clinical, RecordFormat.CCDA]
    : getClassAndFormat(file)

  return createNewRecord(file.name, recordClass, recordFormat, [
    {
      file,
    },
  ])
}

const checkIsCCDA = file => readFileAsText(file).then(text => checkCCDAXSLT(text))

export const isPossibleCCDA = file => {
  const [name, extension] = getFileNameAndExtension(file)
  return ['xml', 'cda', 'ccda'].indexOf(extension.toLowerCase()) >= 0
}

export async function* processNonDicomFiles(files) {
  const filesToProcess = files.filter(_.negate(isIgnoredFile))

  const [nonDicom, possibleDicom] = _.partition(isNonDicomAndValid, filesToProcess)

  const [possibleCCDA, simpleNonDicoms] = _.partition(isPossibleCCDA, nonDicom)

  yield [simpleNonDicoms.map(file => createRecord(file)), []]

  /* eslint-disable no-await-in-loop, no-restricted-syntax */
  for (const file of possibleCCDA) {
    const {
      value: [unlock],
    } = await processQueue.next()
    try {
      const isCCDA = await checkIsCCDA(file)
      yield [[createRecord(file, isCCDA)], []]
    } catch (e) {
      yield [[createRecord(file)], []]
    } finally {
      unlock()
    }
  }

  yield [[], possibleDicom]
}
